import { InputField } from "@/components/InputField";
import { storeSignupContext } from "@/events/signupTracking";
import { addAlert } from "@/redux/message/messageSlice";
import {
  fetchSquads,
  saveSquad,
  updateLoadedSquadIndex,
} from "@/redux/squadBuilder/defaultSquadBuilder/defaultSquadBuilderSlice";
import { AppDispatch } from "@/redux/store";
import { userIsLoggedInSelector } from "@/redux/user/userSlice";
import { useTranslation } from "@repo/shared/i18n";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { LoginSection } from "./LoginSection";

const squadNames = [
  "No Neymar, No Cry",
  "Unreal Madrid",
  "Pique Blinders",
  "Ctrl + Alt + De Ligt",
  "Hakuna Juan Mata",
  "Net Six and Chill",
  "Messi Business",
  "Who Ate All Depays?",
  "Backstreet Moyes",
  "Aston Vanilla",
  "Tiki-Taka Tribe",
  "Icardi B",
  "Park the Bus FC",
  "Weekend Warriors",
  "Kickball Wizards",
  "Sweaty Goals United",
  "FC Crouch Potato",
  "Kroos Control",
  "Silva Lining FC",
  "Muller's Time Machine",
  "Sons of Pitches",
  "Dybala-Rinas",
  "Top Bins United",
  "The Nutmeg Navigators",
  "Game of Throw-Ins",
  "The Dribble Squad",
  "Pjanic! At The Disco",
  "Bayern Munchies",
  "The Offsiders",
  "Header Hunters FC",
  "Keep Calm and Carrick On",
];

interface SaveSquadSectionProps {
  clickedSave: boolean;
  onClose: () => void;
}

export const SaveSquadSection = ({
  clickedSave,
  onClose,
}: SaveSquadSectionProps) => {
  const { t } = useTranslation("squadBuilder");
  const isLoggedIn = useSelector(userIsLoggedInSelector);
  const dispatch = useDispatch<AppDispatch>();
  const [squadName, setSquadName] = useState(
    squadNames[Math.floor(Math.random() * squadNames.length)],
  );
  const [showLoginSection, setShowLoginSection] = useState(false);

  const handleSquadNameChange = (name: string) => {
    setSquadName(name);
  };

  const handleSaveSquad = async () => {
    try {
      await dispatch(saveSquad({ squadName })).unwrap();
      const squads = await dispatch(fetchSquads()).unwrap();
      dispatch(updateLoadedSquadIndex(squads.length - 1));
      onClose();
    } catch (e) {
      dispatch(
        addAlert({
          type: "error",
          description: t("saveSquad.failed"),
        }),
      );
    }
  };

  useEffect(() => {
    if (clickedSave) {
      if (isLoggedIn) {
        handleSaveSquad();
      } else {
        // Forwarded to the backend as the user_signed_up `context` when this
        // save-squad login gate converts an anonymous user.
        storeSignupContext("save_squad");
        setShowLoginSection(true);
      }
    }
  }, [clickedSave]);

  return (
    <div className="flex flex-col mb-2 mt-6 text-center items-center">
      {showLoginSection ? (
        <LoginSection onClose={onClose} handleLoginSuccess={handleSaveSquad} />
      ) : (
        <div className="flex flex-row gap-x-2 w-full">
          <div className="flex flex-col gap-y-2 w-72">
            <label className="text-xs touch-device:text-sm text-dark-secondary mr-auto">
              {t("saveSquad.nameLabel")}
            </label>
            <InputField
              placeholder={t("saveSquad.namePlaceholder")}
              value={squadName}
              onChange={handleSquadNameChange}
              type={"default"}
              large={true}
            />
          </div>
        </div>
      )}
    </div>
  );
};
